import { render, staticRenderFns } from "./teamDirverBind.vue?vue&type=template&id=00f4bbdb&scoped=true"
import script from "./teamDirverBind.vue?vue&type=script&lang=js"
export * from "./teamDirverBind.vue?vue&type=script&lang=js"
import style0 from "./teamDirverBind.vue?vue&type=style&index=0&id=00f4bbdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f4bbdb",
  null
  
)

export default component.exports